import * as React from 'react';
import { type Theme, useStyletron } from 'baseui';
import { NODE_COLOR_PALETTE } from '../../../constants/template-builder';
type PresetColorGridPropsT = {
  selectedColor: string;
  onSelect: (color: string) => void;
};
const getGridStyles = (theme: Theme) => ({
  display: ('grid' as const),
  gridTemplateColumns: 'repeat(8, 1fr)',
  gap: theme.sizing.scale200
});
const getSwatchStyles = (color: string, isSelected: boolean, theme: Theme) => ({
  width: theme.sizing.scale700,
  height: theme.sizing.scale700,
  borderRadius: theme.borders.radius200,
  backgroundColor: color,
  border: 'none',
  cursor: ('pointer' as const),
  padding: '0',
  outline: isSelected ? `2px solid ${theme.colors.borderSelected}` : 'none',
  outlineOffset: theme.sizing.scale0
});
export function PresetColorGrid({
  selectedColor,
  onSelect
}: PresetColorGridPropsT) {
  const [css, theme] = useStyletron();
  return <div className={css(getGridStyles(theme))} data-testid="color-picker-grid">
      {NODE_COLOR_PALETTE.map(color => <button key={color} className={css(getSwatchStyles(color, color === selectedColor, theme))} onClick={() => onSelect(color)} aria-label={color} data-testid={`color-swatch-${color}`} />)}
    </div>;
}